import { yup } from '@guiker/yup-util'

export const leaseByScope = yup.object({
  scopeType: yup.string().required(),
  scopeId: yup.string().required(),
})
